import { Component, ViewChild, ElementRef, OnInit, ChangeDetectorRef, AfterViewInit, Renderer2,NgZone } from '@angular/core';
import { ChatService, Message } from '../core/services/chat.service';
import { HelperService } from 'src/app/core/services/helper.service';
import { Storage } from '@ionic/storage';
import { Subscription, BehaviorSubject, ObjectUnsubscribedError, Observable, Subject } from 'rxjs';
import { BackendService } from 'src/app/core/services/backend-prod.service';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { AlertController } from '@ionic/angular';
import { DialogBoxComponent } from 'src/app/shared/components/dialog-box/dialog-box.component';
import { MatDialog } from '@angular/material/dialog';
import * as moment from 'moment';
import { SafeUrl } from '@angular/platform-browser';
import { CodemirrorComponent } from '@ctrl/ngx-codemirror';
import { ClipboardButtonComponent, MarkdownService } from 'ngx-markdown';
import { CdkVirtualScrollViewport, ScrollDispatcher } from '@angular/cdk/scrolling';
import { Clipboard } from '@angular/cdk/clipboard';
import { MatFormField } from '@angular/material/form-field';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import * as nlp from 'compromise';
import { HttpClient } from '@angular/common/http';

export interface ChatEntry {
  data: any;
}

export class DataSource {
  constructor(public index_name: string, public index_id: number) { }
}
@Component({
  selector: 'app-gold-finch-chat',
  templateUrl: './gold-finch-chat.page.html',
  styleUrls: ['./gold-finch-chat.page.scss'],
})
export class GoldFinchChatPage implements OnInit, AfterViewInit {
  messages: Message[] = [];
  value: string;
  @ViewChild('questionInputBox') questionInputBox: ElementRef;
  @ViewChild("codeEditor") _dlSearchEditor: CodemirrorComponent;
  @ViewChild("scrollChatWindow", { static: false }) scrollChatWindow: ElementRef;
  @ViewChild(CdkVirtualScrollViewport) virtualScroll: CdkVirtualScrollViewport;
  @ViewChild('scrollChatWindow') private myScrollContainer: ElementRef;
  @ViewChild("formField") autoCompleteFormField: MatFormField;

  readonly clipboardButton = ClipboardButtonComponent;

  codeEditorData: string = '';
  codeMirrorEditorOptions: any = {
    lineNumbers: true,
    lineWrapping: true,
    theme: "default",
    mode: { name: "text" }
  };
  isReadonly: boolean = false;

  editorMsg = '';
  userQuestion = '';
  botAnswer = 'initial';

  sending: boolean = false
  writeTimeout: any;
  currentTime = Date.now()

  status: any;
  submitib: boolean = false;

  hash_password: string;
  hash_password_index_mngt: string;

  refresh_token: string;

  currentStatus: any = '';
  isDefault: boolean = false;
  public chatMessage = [];
  // token: any;
  ibid: any;
  token = { 'api-key': '$2b$12$yVHmB/tBgB4dMtXi6jcNeOWRCrzMZsLeiRdAVRo9bNH.dc57/8c2y' };
  count: any = 1;

  data_source_index_name = '';
  ai_modal_name = '';
  data_source_previou_index_name = ''
  ai_modal_previous_name = ""
  conversation_pipeline_name = ""
  isDataSourceIndeNameChanges: boolean = false;
  ai_model = ''
  isNewConversation: boolean = false;
  DataSourceContent = [];

  queryParams = {
    index_name: '',
    pipeline_name: '',
    model_id: '',
    conversation_id: '',
  };
  conversation_name: string;
  conversation_id: any;

  //====== Toke =========//
  goldFInchAPIToken: string;
  type;

  indexMgntList = []
  aiModelList = []
  conversationListNextTokenCount: number = 0;

  neocortexList = []
  loading: boolean = false;
  valueSpinner = 0;
  isNewCOnversation: boolean = false;
  isSpineerLoad: boolean = true;
  profileImagePath: SafeUrl = "../assets/images/profile-avatar.svg";
  indexData = [];
  public chatwebSocketSubscription: Subscription;
  isDataSourceSelected: boolean = false;
  isAIModalSelected: boolean = false;
  showScrollButton: boolean = false;
  initialScrollPosition: number;
  scrollThreshold: number;
  totalInteractions = 0;
  totalInteractionsLoaded = 0;
  nextToken: string = '';
  interactionsArr = [];
  loadingMoreInteractions: boolean = false;
  index_id: number;
  showArrow: boolean = false;
  copyStr: string = 'Copy'
  stateCtrl: FormControl;
  isListening: boolean = false;
  isRecording: boolean = false;
  currentMessage: string = '';
  private recognition: any;
  isAccess:any;
  @ViewChild('questionInputBox') messageInput!: ElementRef;

  indexMgntListNew: DataSource[] = [];
  indexMgntListNew$: Observable<any[]>;
  webSocketConnection:Subject<any>=new Subject();

  constructor(
    public chatService: ChatService,
    public helperService: HelperService,
    public backendService: BackendService,
    public storage: Storage,
    private sanitizer: DomSanitizer,
    public alertController: AlertController,
    private dialog: MatDialog,
    private scrollDispatcher: ScrollDispatcher,
    private renderer: Renderer2,
    private cd: ChangeDetectorRef,
    private _formBuilder: UntypedFormBuilder,
    private clipboard: Clipboard,
    private ngZone: NgZone,
    private http:HttpClient
  ) {
    this.helperService.fromPage = 'goldfinch'
    this.getProfileImage();
    this.stateCtrl = new FormControl();
    this.indexMgntListNew$ = this.stateCtrl.valueChanges
      .pipe(
        startWith(''),
        map(state => state ? this._filterStates(state) : this.indexMgntListNew.slice())
      );
  }

  async getStorage() {
    let data = {
      token: await this.storage.get('token'),
      userId: await this.storage.get('id'),
      showDialog: await this.storage.get('showDialog'),
      catalogobjtype: await this.storage.get('catalogobjtype'),
      ibid: await this.storage.get('ibid'),
      goldFInchRefreshTOken: await this.storage.get('goldFInchRefreshTOken'),
      goldFInchAPIAccessToken: await this.storage.get('goldFInchAPIAccessToken'),
      profile_image_id: await this.storage.get("profile_image_id"),
    };
    return data;
  }

  data() {
    let data = {
      index_name: 'bizintel360-retail_orders',
      pipeline_name: 'bizdata_ai_rag_pipeline_txt2txt',
      model_id: 'VLjUfYwB9_MXHuOCboSr',
      conversation_id: 'cUutoI0BCjm4TK7_PD_M',
    };
    return data;
  }

  createWebSocketConnection(conversation_id) {
    let queryParams = {
      index_name: "bizintel360-"+this.data_source_index_name,
      pipeline_name: this.conversation_pipeline_name,
      model_id: this.ai_modal_name,
      conversation_id: conversation_id,
    }
    this.chatService.initializeWebSocket(this.hash_password, queryParams, "open")
    this.chatwebSocketSubscription = this.chatService.getMessages().subscribe({
      next: (message) => {
        this.currentStatus='running'
        //console.log(message.data);
        this.webSocketConnection.next(message);
        this.handleMessage(message)
      },
      error: (error) => this.handleError(error)
    });
  }

  ngOnInit() {
    this.http.get('assets/feature_switching.json').subscribe((res: any) => {
      this.isAccess = res.voice_command;
    })
    this.generateChatToken();
    this.generateIndexMngtToken();
    // setTimeout(() => {
    //   this.showArrow = true;
    // }, 2000);
    this.webSocketConnection.subscribe((data)=>{
      this.sendMessage()
    })
    const SpeechRecognition = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;
 
    if (!SpeechRecognition) {
      alert('Speech recognition is not supported in this browser.');
      return;
    }
 
    this.recognition = new SpeechRecognition();
    this.recognition.lang = 'en-US';
    this.recognition.interimResults = true;
    this.recognition.continuous = true;
 
    this.recognition.onstart = () => {
        this.isListening = true;
        this.isRecording = true;
    };
 
    this.recognition.onresult = (event: any) => {
        let interimTranscript = '';
        for (let i = event.resultIndex; i < event.results.length; ++i) {
          if (event.results[i].isFinal) {
            this.editorMsg=event.results[i][0].transcript;
            this.sendMessage();
          } else {
            interimTranscript += event.results[i][0].transcript;
          }
        }
        this.currentMessage = interimTranscript;
    };
 
    this.recognition.onerror = (event: any) => {
      this.recognition.stop();
    };
 
    this.recognition.onend = () => {
        this.isListening = false;
        this.isRecording = false;
    };
  }
  startListening(): void {
    if (this.isListening) {
      this.recognition.stop();
    } else if((this.data_source_index_name == '' || this.data_source_index_name == undefined) && (this.ai_modal_name == '' || this.ai_modal_name == undefined)){
      this.confirmIndexNameAlert('Please select data source to start new Neocortex Conversation.');
      return
    }else if((this.data_source_index_name != '' && this.data_source_index_name != undefined) && (this.ai_modal_name == '' || this.ai_modal_name == undefined)){
      this.confirmIndexNameAlert('Please select AI Model to start new Neocortex Conversation.');
      return
    }else if((this.ai_modal_name != '' && this.ai_modal_name != undefined) && (this.data_source_index_name == '' || this.data_source_index_name == undefined)){
      this.confirmIndexNameAlert('Please select data source to start new Neocortex Conversation.');
      return
    }
    else{
      this.recognition.start();
    }
  }


  ngAfterViewInit(): void {
    // this.scrollMoreConversationList()
  }

  onScroll(): void {
    const container = this.scrollChatWindow.nativeElement;
    const atTop = container.scrollTop === 0;
    this.showScrollButton = container.scrollHeight - container.scrollTop - container.clientHeight > 50;
    const isScrolledToBottom = this.scrollChatWindow.nativeElement.scrollHeight - this.scrollChatWindow.nativeElement.scrollTop === this.scrollChatWindow.nativeElement.clientHeight;
    if (isScrolledToBottom) this.scrollToBottom();
    if (atTop && this.messages.length) {
      this.getMoreInteractionsNeocortex();
    }
  }

  scrollToBottom(): void {
    try {
      this.scrollChatWindow.nativeElement.scrollTop = this.scrollChatWindow.nativeElement.scrollHeight;
    } catch (err) { }
  }

  // scrollMoreConversationList() {
  //   this.scrollDispatcher.scrolled().subscribe(event => {
  //     try {
  //       if (this.virtualScroll.measureScrollOffset('bottom') < 1) {
  //         if (this.conversationListNextTokenCount == 0) {
  //           return
  //         }
  //         let python_base_url = environment.goldfinch_base_url + `/conversation/crud?action_type=list_conversation&max_results=10&next_token=${this.conversationListNextTokenCount}`;
  //           this.getStorage().then((res) => {
  //             this.helperService.loader();
  //             this.backendService.PostExternalTokenGoldfinchAPICall(python_base_url, {}, res.goldFInchAPIAccessToken)
  //               .subscribe(
  //                 (data) => {
  //                   this.helperService.closeLoader()
  //                   this.neocortexList = this.neocortexList.concat(data.data.conversations);
  //                   if (data.data.hasOwnProperty('next_token')) {
  //                     this.conversationListNextTokenCount = data.data.next_token;
  //                   } else {
  //                     this.conversationListNextTokenCount = 0;
  //                   }
  //                 },
  //                 (error) => {
  //                   //console.log(error);
  //                   this.helperService.closeLoader();
  //                   this.helperService.presentToast('Oops! something went wrong', 2000);
  //                 }
  //               );
  //           })
  //       }
  //     } catch (error) {
  //       console.error('Error:', error);
  //     }
  //   });
  // }

  smoothScrollToBottom() {
    const chatWindow = this.scrollChatWindow.nativeElement;
    chatWindow.scrollTo({ top: chatWindow.scrollHeight, behavior: 'smooth' });
    this.showScrollButton = false;
  }

  onChangeIndexMgmtName(event, previou_index) {
    this.isDataSourceSelected = false;
    this.data_source_index_name = event.index_name;
    this.index_id = event.index_id;
    this.data_source_previou_index_name = event.index_name;
    if (previou_index == event.index_name) {
      return;
    } else {
      this.isDataSourceSelected = true;
      this.helperService.presentToast('Data Source Selected.', 2000);
    }
    if (this.conversation_id != '' && this.conversation_id != undefined && this.conversation_name != "" && this.conversation_name != undefined && this.ai_modal_name != "" && this.ai_modal_name != undefined) {
      this.closeWebSocketConnection().then((res) => {
        if (res == "Connection Closed") {
          if (this.chatwebSocketSubscription) {
            this.chatwebSocketSubscription.unsubscribe();
          }
          this.createWebSocketConnection(this.conversation_id)
          this.botAnswer = "initial"
        }
      })
    }
  }
  onChangeIndexMgmtNew(event) {

  }
  onChangeAIModal(event, previou_index) {
    this.isAIModalSelected = false;
    this.ai_modal_name = event.ai_model_name;
    this.conversation_pipeline_name = event.conversation_pipeline_name;
    this.ai_modal_previous_name = event.ai_model_name;
    if (previou_index == event.ai_model_name) {
      return;
    } else {
      this.isAIModalSelected = true;
      this.helperService.presentToast('AI Agent Selected.', 2000);
    }
    if (this.conversation_id != '' && this.conversation_id != undefined && this.conversation_name != "" && this.conversation_name != undefined && this.data_source_index_name != "" && this.data_source_index_name != undefined) {
      this.closeWebSocketConnection().then((res) => {
        if (res == "Connection Closed") {
          if (this.chatwebSocketSubscription) {
            this.chatwebSocketSubscription.unsubscribe();
          }
          this.createWebSocketConnection(this.conversation_id)
          this.botAnswer = "initial"
        }
      })
    }
  }

  handleError(error: Error): void {
    // React to the error
    //console.log(error);
  }

  handleMessage(message: MessageEvent): void {
    if (!message.data.includes('Authentication successful')) {
      if (message.data !== "null" && message.data !== null) {
        let data = JSON.parse(message.data)
        this.getBotAnswer(data.answer, data.create_time, data.parent_message_id);
      }
    } else {
      if (this.isDataSourceSelected == false || this.isAIModalSelected == false) {
        this.helperService.presentToast('Neocortex Started.', 2000);
      }
    }
  }

  sendMessage(event?:any) {
    if(this.currentStatus=='stop'){
      this.createWebSocketConnection(this.conversation_id);
    }
    event?.preventDefault();
    this.recognition.stop();
    if (event && event.shiftKey && event.key === 'Enter') {
      if (!this.editorMsg || this.editorMsg.trim() === '') {
        return;
      }
    }
    if (this.editorMsg === '' || this.editorMsg === undefined || this.editorMsg.trim() === '') {
      return;
    }
    let input_text=document.getElementById("stateInput") as HTMLInputElement;
    this.data_source_index_name=input_text.value;
    if((this.ai_modal_name == '' || this.ai_modal_name == undefined) && (this.data_source_index_name == '' || this.data_source_index_name == undefined)) {
      this.confirmIndexNameAlert("Please select Data source and AI Model");
      this.editorMsg = '';
      this.sending=false
      return
    } else if((this.ai_modal_name == '' || this.ai_modal_name == undefined) && (this.data_source_index_name != '' && this.data_source_index_name != undefined)) {
      this.confirmIndexNameAlert("Please select AI Model to start new Neocortex Conversation.");
      this.editorMsg = '';
      this.sending=false
      return
    } else if((this.ai_modal_name != '' && this.ai_modal_name != undefined) && (this.data_source_index_name == '' || this.data_source_index_name == undefined)) {
      this.confirmIndexNameAlert("Please select data source to start new Neocortex Conversation.");
      this.editorMsg = '';
      this.sending=false
      return
    }
    this.questionInputBox.nativeElement.value = '';
    this.sending = true;
    if((this.conversation_id == '' || this.conversation_id == undefined) && (this.ai_modal_name != '' && this.ai_modal_name != undefined) && (this.data_source_index_name != '' && this.data_source_index_name != undefined)) {
      this.StartNewConversation(this.generateChatName(this.editorMsg));
      return
    }
    // let question = {
    //   "question": this.editorMsg.replace(/\n/g, "")
    // }
    let question = {
      "question": this.editorMsg
    }
    this.chatService.sendMessage(question);
    this.sending = true;
    // this.userQuestion = this.editorMsg.replace(/\n/g, "")
    this.userQuestion = this.editorMsg;
    // const userMessage = new Message('user', this.editorMsg.replace(/\n/g, ""), moment.utc().local().format("MMMM D, YYYY, [at] h:mm A"), "", "");
    const userMessage = new Message('user', this.editorMsg, moment.utc().local().format("MMMM D, YYYY, [at] h:mm A"), "", "", "", 0);
    let userMessageObj = {
      create_time: moment().toISOString(),
      input: this.userQuestion,
      response: ""
    }
    this.interactionsArr.push(userMessageObj);
    // //console.log("userMessage", userMessage);
    // //console.log("sendMessage i", this.interactionsArr);
    this.messages = this.messages.concat(userMessage)
    this.botAnswer = ''
    const botMessage = new Message('bot', "", moment.utc().local().format("MMMM D, YYYY, [at] h:mm A"), "", "", "", 0);
    this.messages = this.messages.concat(botMessage)
    this.isReadonly = true;
    // setTimeout(() => {
    //   this.isReadonly = false;
    // }, 20000);
    this.editorMsg = '';
    setTimeout(() => {
      this.scrollToBottom();
    }, 1);
  }

  getUserQuestion(question: string) {
    const formattedDate = moment.utc().format("MMMM D, YYYY, [at] h:mm A [UTC]");
    const userMessage = new Message('user', question, formattedDate, "", "", "", 0);
    this.messages = this.messages.concat(userMessage)
  }

  getBotAnswer(botAnswer: string, timeStamp: string, messageId: string) {
    let index = this.messages.length - 1;
    const utcDate = "2024-03-06T15:30:00Z";
    // const localDate = moment.utc(timeStamp).local().format("MMMM D, YYYY, [at] h:mm A");
    const formattedDate = moment.utc(timeStamp).local().format("MMMM D, YYYY, [at] h:mm A");
    this.messages[index].timeStamp = formattedDate;
    if (this.messages[index].author == "bot") {
      this.botAnswer = botAnswer
      let str: any = botAnswer
      var botAnswerTmp = str
      if (str.includes('```')) {
        botAnswerTmp = str.replaceAll("```", "\`\`\`");
      }
      this.messages[index].content = botAnswerTmp;
      this.messages[index].messageId = messageId;
      this.interactionsArr[this.interactionsArr.length - 1].response = botAnswerTmp;
      this.messages[index].content = '';
      this.typeWriterEffect(botAnswerTmp, index);
    }
    setTimeout(() => {
      this.questionInputBox.nativeElement.focus();
    }, 500)
  }

  typeWriterEffect(text: string, index: number) {
    let i = 0;
    let speed = 20;
    const accelerationLine = 2;

    const type = () => {
      if (i < text.length) {
        this.messages[index].content += text.charAt(i);
        i++;

        if (i === accelerationLine) {
          speed = 10;
        }

        this.writeTimeout = setTimeout(type, speed);
        setTimeout(() => {
          this.scrollChatWindow.nativeElement.scrollTop = this.scrollChatWindow.nativeElement.scrollHeight;
        }, 1);
      }
      else if (i >= text.length) {
        this.sending = false;
        this.isReadonly = false;
      }
    };

    type();

  }

  scrollBar() {
    this.messages = []
  }

  public isAlert=false;
  validateDataSource(event?) {
    this.checkDataSource();
    if(!this.isAlert){
    if ((this.data_source_index_name == '' || this.data_source_index_name == undefined)) {
      this.confirmIndexNameAlert("Please select data source and create new Neocortex Conversation.");
      this.editorMsg = '';
    } else if ((this.data_source_index_name == '' || this.data_source_index_name == undefined)) {
      this.confirmIndexNameAlert("Please select data source to start the Neocortex Conversation.");
      this.editorMsg = '';
    } else if ((this.ai_modal_name == '' || this.ai_modal_name == undefined)) {
      this.confirmIndexNameAlert("Please select AI Model to start the Neocortex Conversation.");
      this.editorMsg = '';
    } else if ((this.data_source_index_name != '' && this.data_source_index_name != undefined) && (this.ai_modal_name == '' || this.ai_modal_name == undefined)) {
      this.confirmIndexNameAlert("Please select AI Model to start the Neocortex Conversation.");
      this.editorMsg = '';
    } else if ((this.data_source_index_name == '' || this.data_source_index_name == undefined) && (this.ai_modal_name != '' && this.ai_modal_name != undefined)) {
      this.confirmIndexNameAlert("Please select data source to start the Neocortex Conversation.");
      this.editorMsg = '';
    } else if ((this.data_source_index_name != '' && this.data_source_index_name != undefined) && (this.ai_modal_name == '' || this.ai_modal_name == undefined)) {
      this.confirmIndexNameAlert("Please select AI Model to start the Neocortex Conversation.");
      this.editorMsg = '';
    }else if(this.editorMsg !==""){
      this.recognition.stop();
    }
  }
  }

  getProfileImage() {
    this.getStorage().then((res) => {
      let payload = {
        "img_collection_id": res.profile_image_id
      }
      let method = 'post';
      this.backendService.fileUpload('getUserProfileImage', method, payload, res.token).subscribe(
        (data: any) => {
          this.profileImagePath = 'data:image/jpg;base64,' + data.profileImage_hash;
        },
        (error) => {
          //console.log(error);
          // this.helperService.presentToast(error.error.detail, 3000);
        }
      )
    })

  }

  updateConversationPompt(neocortex) {
    this.helperService.isUpdatConversationName = true;
    this.helperService.newConversationName = neocortex.conversation_name;
    const dialogRef = this.dialog.open(DialogBoxComponent, {
      width: '500px',
      height: '255px',
    },);

    dialogRef.afterClosed().subscribe((data) => {
      if (data.clicked === 'submit') {
        this.conversation_name = data.form.name
        this.helperService.newConversationName = "";
        this.helperService.isUpdatConversationName = false;
        this.updateConversationName(neocortex, data.form.name)
      }
    });
  }

  updateConversationName(conversation, newConversatoinName) {
    this.helperService.loader()
    let python_base_url = environment.goldfinch_base_url + `/conversation/crud?action_type=update_conversation&conversation_id=${conversation.conversation_id}`;
    let reqBody = {
      name: newConversatoinName
    }
    this.getStorage().then((res) => {
      this.backendService.PostExternalTokenGoldfinchAPICall(python_base_url, reqBody, res.goldFInchAPIAccessToken)
        .subscribe(
          (data) => {
            //console.log(data.data)
            this.helperService.closeLoader()
            this.conversation_name = newConversatoinName;
            this.helperService.presentToast(data.message, 2000);
            this.getConversationList()
          },
          (error) => {
            this.helperService.closeLoader()
            //console.log(error);
            this.helperService.handleError(error);
          }
        );
    })
  }

  //========================== Fetching all the existing conversation ======================//

  getConversationList() {
    this.getStorage().then((res) => {
      let python_base_url = environment.goldfinch_base_url + `/conversation/crud?action_type=list_conversation_by_user&user_id=${res.userId}`;
      this.backendService.PostExternalTokenGoldfinchAPICall(python_base_url, {}, res.goldFInchAPIAccessToken)
        .subscribe(
          (data) => {
            this.neocortexList = [];
            if (data.hasOwnProperty('data')) {
              if (data.data.hasOwnProperty('conversations')) {
                this.neocortexList = data.data.conversations;
              }
            }
            this.conversation_id = this.conversation_id;
            this.questionInputBox.nativeElement.focus();
          },
          (error) => {
            //console.log(error);
            this.loading = true;
            this.helperService.handleError(error);
          }
        );
    })
  }

  getInteractionsNeocortex(conversation_id, neocortex_name) {
    let python_base_url = environment.goldfinch_base_url + `/conversation/crud?action_type=list_interaction&conversation_id=${conversation_id}&max_results=10&next_token=0`;
    this.getStorage().then((res) => {
      this.backendService.PostExternalTokenGoldfinchAPICall(python_base_url, {}, res.goldFInchAPIAccessToken)
        .subscribe(
          (data) => {
            this.scrollBar();
            this.showScrollButton = false;
            this.isNewConversation = true;
            this.isReadonly = false;
            this.editorMsg = '';
            this.conversation_name = neocortex_name;
            this.conversation_id = conversation_id;
            this.totalInteractions = data.data?.total_items;
            this.totalInteractionsLoaded = data.data?.this_page_data_counts;
            if (data.hasOwnProperty('data')) {
              if (data.data.hasOwnProperty('interactions')) this.interactionsArr = data.data.interactions;
              else this.interactionsArr = [];
              if (data.data.hasOwnProperty('next_token')) this.nextToken = data.data.next_token;
              else this.nextToken = "";
            }

            this.fillConversatinChat(this.interactionsArr, false);
          },
          (error) => {
            //console.log(error);
            // this.helperService.closeLoader();
            this.helperService.handleError(error);
          }
        );
    })
  }

  getMoreInteractionsNeocortex() {
    if (this.nextToken != "" && this.nextToken != undefined) {
      let interactions = [];
      this.loadingMoreInteractions = true;
      let python_base_url = environment.goldfinch_base_url + `/conversation/crud?action_type=list_interaction&conversation_id=${this.conversation_id}&max_results=10&next_token=${this.nextToken}`;
      this.getStorage().then((res) => {
        this.backendService.PostExternalTokenGoldfinchAPICall(python_base_url, {}, res.goldFInchAPIAccessToken)
          .subscribe(
            (data) => {
              this.totalInteractionsLoaded = this.totalInteractionsLoaded + data.data.this_page_data_counts;
              if (data.hasOwnProperty('data')) {
                if (data.data.hasOwnProperty('next_token')) this.nextToken = data.data.next_token;
                else this.nextToken = "";
              }

              interactions = data.data.interactions;
              this.interactionsArr.unshift(...interactions);
              this.fillConversatinChat(this.interactionsArr, true)
            },
            (error) => {
              //console.log(error);
              this.loadingMoreInteractions = false;
              this.helperService.handleError(error);
            }
          );
      })
    }
  }

  dislikeMessage(messageId: string, index: number) {
    const dislikeState =  1;
    let python_base_url = environment.goldfinch_base_url + `/conversation/likeDislikeMessage?parent_message_id=${messageId}&is_dislike=${dislikeState}`;
      this.getStorage().then((res) => {
        this.backendService.PutExternalTokenGoldfinchAPICall(python_base_url, {}, res.goldFInchAPIAccessToken)
          .subscribe(
            (data) => {
              this.messages[index].is_dislike = dislikeState;
              //console.log('Dislike action successful');
            },
            (error) => {
              //console.log(error);
              this.helperService.handleError(error);
            }
          );
      })  
  }

  closeWebSocketConnection() {
    return new Promise((resolve) => {
      let connection = ''
      connection = 'Connection Closed'
      this.chatService.closeWebSocket();
      resolve(connection);
    })
  }

  async fillConversatinChat(conversatinList, isLoadMore?) {
    this.fillConv(conversatinList).then((res) => {
      if (res) {
        // First time load Interactions
        if (isLoadMore == false) {
          setTimeout(() => {
            this.scrollToBottom();
          }, 1);
        } else {
          this.loadingMoreInteractions = false;
          this.scrollChatWindow.nativeElement.scrollTop = 5;
        }
      }
    });
    if (isLoadMore == false) {
      this.closeWebSocketConnection().then((res) => {
        if (res == "Connection Closed") {
          this.botAnswer = "initial"
          if (this.chatwebSocketSubscription) {
            this.chatwebSocketSubscription.unsubscribe();
          }
          if (this.data_source_index_name != "" && this.data_source_index_name != undefined) {
            this.createWebSocketConnection(this.conversation_id)
          }
        }
      })
    }

  }

  fillConv(conversatinList) {
    return new Promise((resolve) => {
      this.messages = [];
      if (conversatinList.length > 0) {
        for (let conversation of conversatinList) {
          const userMessage = new Message('user', conversation.input, moment.utc(conversation.create_time).local().format("MMMM D, YYYY, [at] h:mm A"), "", "", "", 0);
          this.messages = this.messages.concat(userMessage)
          let str: any = conversation.response
          var botAnswerTmp = str
          if (str.includes('```')) {
            botAnswerTmp = str.replaceAll("```", "\`\`\`");
          }
          const botMessage = new Message('bot', botAnswerTmp, moment.utc(conversation.create_time).local().format("MMMM D, YYYY, [at] h:mm A"), "", "", conversation.parent_message_id, conversation.is_dislike);
          this.messages = this.messages.concat(botMessage)
        }
      }
      resolve(this.messages);
    })
  }

  //==========================================================================================//

  async getIndexMngmtList() {
    return new Promise((resolve) => {
      this.getStorage().then((res) => {
        let python_base_url = environment.goldfinch_base_url + `/IndexManagement?action_type=get_user_indexes&filter_by=bizintel360-ai_*&user_id=${res.userId}`;
        this.backendService.PostExternalTokenGoldfinchAPICall(python_base_url, {}, res.goldFInchAPIAccessToken).subscribe(
          data => {            
            let dl: any[] = data as any[];
            this.helperService.closeLoader();
            this.questionInputBox.nativeElement.focus();
            resolve(dl);
          }, (error) => {
            //console.log(error);
            this.helperService.closeLoader();
            this.helperService.handleError(error);
          })
      })
    })
  }
  //=====================//

  //==========================================================================================//

  async getAIModelList() {
    return new Promise((resolve) => {
      this.getStorage().then((res) => {
        let python_base_url = environment.goldfinch_base_url + '/getModels';
        this.backendService.getExternalTokenGoldfinchAPICall(python_base_url, res.goldFInchAPIAccessToken).subscribe(
          data => {
            let dl: any[] = data as any[];
            resolve(dl);
          })
      })
    })
  }
  //=====================//

  async confirmDelectAlert(neocortex) {
    const alert = await this.alertController.create({
      header: 'Alert!',
      message: `Are you sure? You want to delete ${neocortex.conversation_name} Neocortex. `,
      buttons: [
        {
          text: 'No',
          cssClass: 'primary-text',
          handler: () => {
            alert.dismiss();
          },
        },
        {
          text: 'Yes',
          cssClass: 'primary-text',
          handler: () => {
            this.deleteConversation(neocortex.conversation_id)
          },
        },
      ],
    });
    await alert.present();
  }

  //===========================Delete Converation based on ID======================//
  deleteConversation(conversation_id) {
    let python_base_url = environment.goldfinch_base_url + `/conversation/crud?action_type=delete&conversation_id=${conversation_id}`;
    this.getStorage().then((res) => {
      this.backendService.PostExternalTokenGoldfinchAPICall(python_base_url, {}, res.goldFInchAPIAccessToken)
        .subscribe(
          data => {
            this.isNewConversation = false;
            if (conversation_id == this.conversation_id) {
              this.messages = []
              this.conversation_id = '';
            }
            this.getConversationList();
            this.helperService.presentToast("Neocortex Deleted Successfully.", 2000);
          },
          error => {
            // this.helperService.closeLoader();
            this.helperService.handleError(error);
          })
    })
  }//==================================//

  ngOnDestroy(): void {
    if (this.chatwebSocketSubscription) {
      this.chatwebSocketSubscription.unsubscribe();
    }
    this.helperService.fromPage = '';
  }

  //============================ Authentication ======================================//

  //------------- Generate Hash_Password (Websocket token) ------------------//
  generateChatToken() {
    return new Promise((resolve) => {
      this.getStorage().then((res) => {
        let payload = {
          type: 'goldfinch_chat'
        }
        this.backendService.postApiTermsCall('getApiTerms', payload, res.token).subscribe(
          (data) => {
            this.hash_password = data['data'][0].hashed_password;
            // //console.log("hash_password_goldfinch_chat - " + this.hash_password)
            resolve(data['data'][0].hashed_password);
          },
          (error) => {
            this.helperService.closeLoader()
            //console.log(error);
          }
        );
      });
    });
  }

  //------------- Generate Hash_Password (Chat crud) ------------------//
  generateIndexMngtToken() {
    return new Promise((resolve) => {
      this.getStorage().then((res) => {
        this.helperService.loader()
        let payload = {
          type: 'index_management'
        }
        this.backendService.postApiTermsCall('getApiTerms', payload, res.token).subscribe(
          (data) => {
            this.hash_password_index_mngt = data['data'][0].hashed_password;
            // //console.log("hash_password_index_management - " + this.hash_password_index_mngt)
            this.GenerateRefreshToken(data['data'][0].username, data['data'][0].hashed_password).then((refresh_token) => {
              this.storage.set("goldFInchRefreshTOken", refresh_token);
              //console.log(data);
              resolve(data);
            })
          },
          (error) => {
            this.helperService.closeLoader()
            //console.log(error);
          }
        );
      });
    });
  }

  //------------- Generate Refresh Token ------------------//
  GenerateRefreshToken(userName?, password?) {
    const payload = new FormData();
    payload.append('username', userName);
    payload.append('password', password);

    let python_base_url = environment.goldfinch_base_url + '/refresh/token';
    return new Promise((resolve) => {
      this.backendService.PostExternalTokenAPICall(python_base_url, payload).subscribe(
        (data) => {
          this.refresh_token = data.refresh_token
          // //console.log("goldfinch_refresh_token - " + data.refresh_token)
          this.generateAccessToken(data.refresh_token).then((access_token) => {
            this.storage.set("goldFInchAPIAccessToken", access_token);
            this.getConversationList();
            this.getIndexMngmtList().then(res => {
              // this.helperService.closeLoader
              let data = res as any;
              for(let obj of data.data){
                obj.index_name = obj.index_name.split("bizintel360-")[1];
                this.indexMgntList.push(obj);
                this.indexMgntListNew.push(obj);
              }
              // this.indexMgntList = data.data;
              if (data.data.length > 0) {
                this.isDataSourceSelected = true;
                this.data_source_index_name = this.indexMgntList[0].index_name;
              } else {
                this.isDataSourceSelected = false;
                this.data_source_index_name = '';
              }
              // this.indexMgntListNew = data.data;
              this.stateCtrl.patchValue(this.indexMgntList[0].index_name);
              this.data_source_previou_index_name=this.indexMgntList[0].index_name;
              this.index_id = this.indexMgntList[0].index_id;
              this.indexMgntListNew$ = this.stateCtrl.valueChanges
                .pipe(
                  startWith(''),
                  map(state => state ? this._filterStates(state) : this.indexMgntListNew.slice())
                );
            });
            this.getAIModelList().then((res) => {
              let data = res as any;
              // //console.log(data)
              this.aiModelList = data.data
              if (data.data.length > 0) {
                this.isAIModalSelected = true;
                this.ai_modal_name = this.aiModelList[0].ai_model_name;
                this.conversation_pipeline_name = this.aiModelList[0].conversation_pipeline_name;
              } else {
                this.isAIModalSelected = false;
                this.ai_modal_name = '';
              }
            })
            resolve(data.refresh_token);
          })
          // resolve(data.refresh_token);
        },
        (error) => {
          this.helperService.closeLoader()
          //console.log(error);
        });
    });
  }

  //------------- Generate Access Token ------------------//
  generateAccessToken(refresh_token) {
    const payload = new FormData();
    payload.append('refresh_token', refresh_token);
    let python_base_url = environment.goldfinch_base_url + '/token';
    return new Promise((resolve) => {
      this.backendService.PostExternalTokenAPICall(python_base_url, payload).subscribe(
        (data) => {
          // //console.log("goldfinch_access_token - " + data.access_token)
          resolve(data.access_token);
        },
        (error) => {
          this.helperService.closeLoader()
          //console.log(error);
        });
    });
  }

  //=========================================================================================//

  //============================ Start New Conversation ======================================//

  //------------- Confrimation of Select Index ------------------//
  async confirmIndexNameAlert(message) {
    this.isAlert=true;
    const alert = await this.alertController.create({
      header: 'Alert!',
      message: message,
      buttons: [
        {
          text: 'Ok',
          cssClass: 'primary-text',
          handler: () => {
            this.recognition.stop();
            alert.dismiss();
            this.isAlert=false;
            this.editorMsg="";
          },
        },
      ],
    });
    await alert.present();
  }

  async selectedIndexNameAlert(message) {
    const alert = await this.alertController.create({
      header: 'Data Source',
      message: message,
      buttons: [
        {
          text: 'Ok',
          cssClass: 'primary-text',
          handler: () => {
            alert.dismiss();
          },
        },
      ],
    });
    await alert.present();
  }

  //------------- New convresatin name prompt ------------------//
  showPrompt(): void {
    this.checkDataSource();
    if ((this.data_source_index_name == '' || this.data_source_index_name == undefined) && (this.ai_modal_name == '' || this.ai_modal_name == undefined)) {
      this.isNewConversation = false;
      this.confirmIndexNameAlert('Please select data source to start new Neocortex Conversation.');
      return
    }
    if ((this.data_source_index_name != '' && this.data_source_index_name != undefined) && (this.ai_modal_name == '' || this.ai_modal_name == undefined)) {
      this.isNewConversation = false;
      this.confirmIndexNameAlert('Please select AI Model to start new Neocortex Conversation.');
      return
    }
    if ((this.ai_modal_name != '' && this.ai_modal_name != undefined) && (this.data_source_index_name == '' || this.data_source_index_name == undefined)) {
      this.isNewConversation = false;
      this.confirmIndexNameAlert('Please select data source to start new Neocortex Conversation.');
      return
    }

    this.helperService.isUpdatConversationName = false;
    this.helperService.newConversationName = "";
    const dialogRef = this.dialog.open(DialogBoxComponent, {
      width: '500px',
      height: '255px',
    },);

    dialogRef.afterClosed().subscribe((data) => {
      if (data.clicked === 'submit') {
        this.conversation_name = data.form.name;
        this.StartNewConversation(data.form.name);
      }
    });
  }

  //------------- New Conversation API ------------------//
  StartNewConversation(conversation_name) {
    this.isNewConversation = true;
    this.showScrollButton = false;
    this.botAnswer = 'initial'
    let payload = {
      "name": conversation_name
    }
    this.getStorage().then((res) => {
      let python_base_url = environment.goldfinch_base_url + `/conversation/crud?action_type=create&index_id=${this.index_id}&user_id=${res.userId}`;
      this.backendService.PostExternalTokenGoldfinchAPICall(python_base_url, payload, res.goldFInchAPIAccessToken)
        .subscribe(
          data => {
            this.messages = [];
            this.conversation_id = data.data.conversation_id;
            this.getConversationList();
            this.closeWebSocketConnection().then((res) => {
              if (res == "Connection Closed") {
                if (this.chatwebSocketSubscription) {
                  this.chatwebSocketSubscription.unsubscribe();
                }
                this.createWebSocketConnection(data.data.conversation_id);
              }
            })
            this.helperService.presentToast('New Neocortex Conversation Started Successfully.', 2000);
          },
          error => {
            // this.helperService.closeLoader();
            this.helperService.handleError(error);
          })
    })
  }//---------------------------------------------------//

  private _filterStates(value: string): DataSource[] {
    const filterValue = value.toLowerCase();
    return this.indexMgntListNew.filter(item => item.index_name.toLowerCase().includes(filterValue));
  }

  onEnter(evt: any) {
    if (evt.source.selected) {
      //console.log("hello ");
    }
  }
  stopResponse() {
    this.closeWebSocketConnection().then((res) => {
      if (res == "Connection Closed") {
        if (this.chatwebSocketSubscription) {
          this.chatwebSocketSubscription.unsubscribe();
          this.currentStatus='stop'
          if (this.messages[this.messages.length - 1].content === '') {
            this.messages.pop();
            const botMessage = new Message('bot', "Please try again", moment.utc().local().format("MMMM D, YYYY, [at] h:mm A"), "", "", "", 0);
            this.messages = this.messages.concat(botMessage);
          }

          this.isReadonly = false;
        }
        clearTimeout(this.writeTimeout);

        this.sending = false;
        this.questionInputBox.nativeElement.focus();
      }
    })
  }
  checkDataSource(){
    let input_text=document.getElementById("stateInput") as HTMLInputElement;
    const index = this.indexMgntListNew.findIndex(item =>
      (item.index_name.toLowerCase()===(input_text.value.toLowerCase()))
    );
    return this.data_source_index_name=(index !== -1)?input_text.value:"";
  }
  copyResponse(index: number) {
    this.copyStr = 'Copied'
    let element = document.getElementById(`bot_message_${index}`)
    let cpyBtns=element.getElementsByTagName('button');
    for(let btn of cpyBtns){
      btn.style.display='none';
    }
    this.clipboard.copy(element.innerText);
    for(let btn of cpyBtns){
      btn.style.display='block';
    }
    setTimeout(() => {
      this.copyStr = 'Copy';
    }, 2000);
  }
 

  regenerateResponse(index: number) {
      this.editorMsg = this.messages[index - 1].content
      this.validateDataSource()
      this.sendMessage();
  }

  openLink(index){
    let element=document.getElementById(`bot_message_${index}`)
    let hrefs=element.getElementsByTagName('a')
    for(let href of hrefs){
      href.setAttribute('target','_blank')
    }
  }

  generateChatName(message: string): string {
    if (!message || typeof message !== 'string') return 'Untitled Chat';
    const doc = nlp(message);
    const nouns = doc.nouns().out('array').filter((word: string) => word.length > 2);
    const verbs = doc.verbs().out('array').filter((word: string) => word.length > 2);
    const adjectives = doc.adjectives().out('array').filter((word: string) => word.length > 2);
    const stopwords = ['the', 'a', 'an', 'in', 'on', 'for', 'and', 'of', 'to', 'is', 'it', 'this', 'that', 'help', 'apply', 'can', 'what', 'how', 'why', 'when'];
    const filteredNouns = nouns.filter(word => (!stopwords.includes(word.toLowerCase())));
    const filteredVerbs = verbs.filter(word => (!stopwords.includes(word.toLowerCase())));
    const filteredAdjectives = adjectives.filter(word => (!stopwords.includes(word.toLowerCase())));
    let keys=[...filteredVerbs, ...filteredNouns]
    let keywords=[]
    for(let key of keys){
      if(!keywords.includes(key)){
        keywords.push(key)
      }
    }
    if (keywords.length === 0) {
      return message.split(' ').slice(0, 5).join(' ') + '...';
    }
    keywords = keywords.slice(0, 5);
    const title = [...keywords].slice(0, 5).join(' ');
    return title.charAt(0).toUpperCase() + title.slice(1);
  }
  clearDataSource(){
    this.stateCtrl.reset();
    this.data_source_index_name="";
  }
}


